<form
  #form
  (ngSubmit)="submit()"
  [appApiAction]="formPromise"
  class="tw-container tw-mx-auto"
  ngNativeValidate
  autocomplete="off"
>
  <!-- ===== EMAIL 2FA ===== -->
  <ng-container *ngIf="selectedProviderType === providerType.Email">
    <div class="two-factor-card tw-rounded-2xl tw-p-6 sm:tw-px-6">
      <!-- Envelope illustration -->
      <div class="tw-flex tw-justify-center tw-mb-5">
        <icon name="email2FA" [size]="20"></icon>
      </div>

      <!-- Title -->
      <h2
        class="tw-text-center tw-font-bold tw-text-[18px] tw-text-dt-slate-12 tw-mb-3 tw-leading-snug"
      >
        {{ "enterVerificationCode" | i18n }}
      </h2>

      <!-- Subtitle -->
      <p
        class="tw-justify-between tw-text-center tw-text-[14px] tw-text-dt-slate-11 tw-mb-6 tw-leading-relaxed"
      >
        {{ "enterVerificationCodeEmailPrefix" | i18n }}<br />
        <span class="tw-font-bold tw-text-dt-slate-12">{{ twoFactorEmail }}</span>
      </p>

      <!-- VERIFICATION CODE label -->
      <label
        id="otp-label"
        class="tw-block tw-text-[11px] tw-font-semibold tw-uppercase tw-tracking-widest tw-text-dt-slate-9 tw-mb-3 tw-px-2"
      >
        {{ "verificationCode" | i18n }}
      </label>

      <!-- 6 OTP input boxes -->
      <div
        class="tw-flex tw-gap-2 tw-mb-2 tw-justify-between tw-px-2"
        role="group"
        aria-labelledby="otp-label"
      >
        <input
          *ngFor="let digit of otpDigits; let i = index; trackBy: trackByIndex"
          #otpInput
          type="text"
          inputmode="numeric"
          maxlength="1"
          placeholder="-"
          autocomplete="one-time-code"
          [attr.aria-label]="'Digit ' + (i + 1)"
          required
          class="tw-w-14 tw-h-14 tw-shrink-0 tw-text-center tw-text-[18px] tw-font-semibold tw-rounded-xl tw-border tw-border-dt-slate-6 tw-bg-dt-slate-1 tw-text-dt-slate-12 placeholder:tw-text-dt-slate-6 focus:tw-border-dt-custom-teal-9 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-dt-custom-teal-9 tw-transition-colors"
          (input)="onOtpInput($event, i)"
          (keydown)="onOtpKeyDown($event, i)"
          (paste)="onOtpPaste($event)"
          (focus)="onOtpFocus($event)"
        />
      </div>

      <!-- Resend link -->
      <div class="tw-mb-5 tw-px-2">
        <a
          href="#"
          appStopClick
          (click)="sendEmail(true)"
          [appApiAction]="emailPromise"
          class="tw-text-[13px] tw-text-dt-custom-teal-11 hover:tw-underline"
        >
          {{ "sendVerificationCodeEmailAgain" | i18n }}
        </a>
      </div>

      <!-- Remember me -->
      <app-checkbox
        id="remember"
        [title]="'rememberMe' | i18n"
        class="tw-font-semibold tw-text-[12px] tw-text-dt-slate-10 tw-mb-6 tw-block tw-px-2"
        [checked]="remember"
        (onChange)="remember = $event"
      ></app-checkbox>

      <!-- Captcha (only rendered when server requires it) -->
      <div [hidden]="!showCaptcha()" class="tw-mb-4 tw-px-2">
        <iframe id="hcaptcha_iframe" height="80"></iframe>
      </div>

      <!-- Continue button -->
      <div class="tw-flex tw-flex-col tw-gap-5 tw-mt-6 tw-px-2">
        <app-gloss-button
          [options]="{
            text: 'continue' | i18n,
            type: 'submit',
            fullClass:
              'tw-bg-dt-custom-teal-11 tw-h-12 tw-w-full tw-px-6 tw-rounded-full tw-text-white tw-font-bold',
            isEnabled: !form.loading,
            onClick: onContinueClick,
          }"
          fontClass="!tw-font-bold tw-text-[16px] tw-text-dt-slate-0"
          [isLoading]="form.loading"
        ></app-gloss-button>

        <!-- Cancel -->
        <div class="tw-text-center tw-mb-2">
          <a
            routerLink="/login"
            class="tw-text-[14px] tw-text-dt-slate-11 hover:tw-underline tw-cursor-pointer tw-font-bold"
          >
            {{ "cancel" | i18n }}
          </a>
        </div>

        <!--
          TODO: This Email screen does not currently offer a "use another
          two-step method" option (anotherMethod()). Users with multiple 2FA
          providers configured have no way to switch away from Email here.
          To be implemented at a later date.
        -->
      </div>
    </div>
  </ng-container>

  <!-- ===== AUTHENTICATOR / OTHER TEXT-CODE PROVIDERS ===== -->
  <ng-container *ngIf="selectedProviderType === providerType.Authenticator">
    <div class="two-factor-card sm:tw-px-6">
      <p class="tw-text-center tw-font-bold tw-text-[18px] tw-text-dt-slate-12 tw-mb-4">
        {{ title }}
      </p>
      <p class="tw-text-[13px] tw-text-dt-slate-11 tw-mb-4">
        {{ "enterVerificationCodeApp" | i18n }}
      </p>
      <div class="form-group tw-mb-4">
        <label for="code" class="sr-only">{{ "verificationCode" | i18n }}</label>
        <input
          id="code"
          type="text"
          name="Code"
          class="form-control"
          [(ngModel)]="token"
          required
          appAutofocus
          inputmode="tel"
          appInputVerbatim
        />
      </div>
      <div class="form-check tw-mb-4">
        <input
          id="remember"
          type="checkbox"
          name="Remember"
          class="form-check-input"
          [(ngModel)]="remember"
        />
        <label for="remember" class="form-check-label">{{ "rememberMe" | i18n }}</label>
      </div>
      <div [hidden]="!showCaptcha()">
        <iframe id="hcaptcha_iframe" height="80"></iframe>
      </div>
      <div class="tw-flex tw-flex-col tw-gap-3">
        <app-gloss-button
          [options]="{
            text: 'continue' | i18n,
            type: 'submit',
            fullClass: 'tw-bg-dt-custom-teal-11 tw-h-12 tw-w-full tw-px-6 tw-rounded-full',
            isEnabled: !form.loading,
            onClick: submit.bind(this),
          }"
          fontClass="!tw-font-bold tw-text-[16px] tw-text-dt-slate-0"
          [isLoading]="form.loading"
        ></app-gloss-button>
        <div class="tw-text-center">
          <a routerLink="/login" class="tw-text-[14px] tw-text-dt-slate-11 hover:tw-underline">
            {{ "cancel" | i18n }}
          </a>
        </div>
      </div>
      <div class="tw-text-center tw-mt-4">
        <a
          href="#"
          appStopClick
          (click)="anotherMethod()"
          class="tw-text-[13px] tw-text-dt-custom-teal-9 hover:tw-underline"
          >{{ "useAnotherTwoStepMethod" | i18n }}</a
        >
      </div>
    </div>
  </ng-container>

  <!-- ===== YUBIKEY ===== -->
  <ng-container *ngIf="selectedProviderType === providerType.Yubikey">
    <div class="two-factor-card">
      <p class="lead tw-text-center tw-mb-4">{{ title }}</p>
      <p class="tw-text-center">{{ "insertYubiKey" | i18n }}</p>
      <div class="form-group">
        <label for="code" class="sr-only">{{ "verificationCode" | i18n }}</label>
        <input
          id="code"
          type="password"
          name="Code"
          class="form-control"
          [(ngModel)]="token"
          required
          appAutofocus
          appInputVerbatim
          autocomplete="new-password"
        />
      </div>
      <div class="form-check">
        <input
          id="remember"
          type="checkbox"
          name="Remember"
          class="form-check-input"
          [(ngModel)]="remember"
        />
        <label for="remember" class="form-check-label">{{ "rememberMe" | i18n }}</label>
      </div>
      <div [hidden]="!showCaptcha()">
        <iframe id="hcaptcha_iframe" height="80"></iframe>
      </div>
      <div class="d-flex mb-3">
        <button
          type="submit"
          class="btn btn-primary btn-block btn-submit"
          [disabled]="form.loading"
        >
          <span><i class="bwi bwi-sign-in" aria-hidden="true"></i> {{ "continue" | i18n }}</span>
          <i class="bwi bwi-spinner bwi-spin" title="{{ 'loading' | i18n }}" aria-hidden="true"></i>
        </button>
        <a routerLink="/login" class="btn btn-outline-secondary btn-block ml-2 mt-0">
          {{ "cancel" | i18n }}
        </a>
      </div>
      <div class="text-center">
        <a href="#" appStopClick (click)="anotherMethod()">{{
          "useAnotherTwoStepMethod" | i18n
        }}</a>
      </div>
    </div>
  </ng-container>

  <!-- ===== WEBAUTHN ===== -->
  <ng-container *ngIf="selectedProviderType === providerType.WebAuthn">
    <div class="two-factor-card">
      <p class="lead text-center mb-4">{{ title }}</p>
      <div id="web-authn-frame" class="mb-3">
        <iframe id="webauthn_iframe" [attr.allow]="webAuthnAllow"></iframe>
      </div>
      <i
        class="bwi bwi-spinner text-muted bwi-spin pull-right"
        title="{{ 'loading' | i18n }}"
        *ngIf="form.loading"
        aria-hidden="true"
      ></i>
      <div class="form-check">
        <input
          id="remember"
          type="checkbox"
          name="Remember"
          class="form-check-input"
          [(ngModel)]="remember"
        />
        <label for="remember" class="form-check-label">{{ "rememberMe" | i18n }}</label>
      </div>
      <div [hidden]="!showCaptcha()">
        <iframe id="hcaptcha_iframe" height="80"></iframe>
      </div>
      <div class="d-flex mb-3">
        <a routerLink="/login" class="btn btn-outline-secondary btn-block mt-0">
          {{ "cancel" | i18n }}
        </a>
      </div>
    </div>
  </ng-container>

  <!-- ===== DUO ===== -->
  <ng-container
    *ngIf="
      selectedProviderType === providerType.Duo ||
      selectedProviderType === providerType.OrganizationDuo
    "
  >
    <div class="two-factor-card">
      <p class="lead text-center mb-4">{{ title }}</p>
      <div id="duo-frame" class="mb-3">
        <iframe id="duo_iframe"></iframe>
      </div>
      <div class="form-check">
        <input
          id="remember"
          type="checkbox"
          name="Remember"
          class="form-check-input"
          [(ngModel)]="remember"
        />
        <label for="remember" class="form-check-label">{{ "rememberMe" | i18n }}</label>
      </div>
      <div [hidden]="!showCaptcha()">
        <iframe id="hcaptcha_iframe" height="80"></iframe>
      </div>
      <div class="d-flex mb-3">
        <a routerLink="/login" class="btn btn-outline-secondary btn-block mt-0">
          {{ "cancel" | i18n }}
        </a>
      </div>
    </div>
  </ng-container>

  <!-- ===== NO PROVIDER ===== -->
  <ng-container *ngIf="selectedProviderType == null">
    <div class="two-factor-card">
      <p>{{ "noTwoStepProviders" | i18n }}</p>
      <p>{{ "noTwoStepProviders2" | i18n }}</p>
      <div [hidden]="!showCaptcha()">
        <iframe id="hcaptcha_iframe" height="80"></iframe>
      </div>
      <a routerLink="/login" class="btn btn-outline-secondary btn-block mt-0">
        {{ "cancel" | i18n }}
      </a>
    </div>
  </ng-container>
</form>
<ng-template #twoFactorOptions></ng-template>
